import React from 'react';
import { PageBanner } from '../components/PageBanner';
import { AboutSection } from '../components/AboutSection';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { EmploymentSection } from '../components/EmploymentSection';
export function AboutPage() {
  return <main data-id="element-368">
      <PageBanner title="About Us" subtitle="Learn more about our mission, our team, and our commitment to your care." breadcrumbs={[{
      label: 'About Us',
      path: '/about'
    }]} data-id="element-369" />
      <AboutSection data-id="element-370" />
      <WhyChooseUs data-id="element-371" />
      <EmploymentSection data-id="element-372" />
    </main>;
}